<app-header
  [transparent]="false"
  [title]="i18n.langString('history')"
></app-header>

@if (loading()) {
  <div class="spinner-container">
    <app-spinner [black]="true"></app-spinner>
  </div>
}
@if (asset() && !loading()) {
  <div class="content" [class.desktop]="isDesktop()">
    @if (isDesktop()) {
      <div class="desktop-sidebar white-sidebar">
        <app-sidebar
          [showList]="true"
          [asset]="asset()"
          [sensorID]="sensorID()"
          [telemetry]="sensor()?.telemetry?.[0]"
        >
        </app-sidebar>
      </div>
    }

    <div
      [class.desktop-main]="isDesktop()"
      [class.white-sidebar-main]="isDesktop()"
    >
      @if (!isDesktop() && asset()?.breadcrumbs && !breadcrumbsLoading()) {
        <app-breadcrumbs
          [isAsset]="true"
          [showCurrent]="true"
          [additionalBC]="'History'"
          class="detail-bold"
        >
        </app-breadcrumbs>
      }

      @if (breadcrumbsLoading()) {
        <app-spinner class="crumbs-spinner" [black]="true"></app-spinner>
      }

      @if (documentationAdded()) {
        <div class="ga-documentation-note body-bold">
          <i nz-icon nzType="icons:done" class="svg-icon"></i>
          <span>{{ i18n.langString("add_documentation_success") }}</span>
        </div>
      }

      <div class="sensor-header flat-sensor">
        <div
          class="sensor-header-inner-div"
          [class.mobile]="isMobile()"
          [class.tablet]="isTablet()"
        >
          <div class="sensor-header-inner-content">
            <i nz-icon nzType="icons:history" class="sensor-icon svg-icon"></i>
            <h2 class="history-sub-header">{{ i18n.langString("history") }}</h2>

            @if (!isDesktop() && sensor()) {
              <div class="detail lighter-label">
                {{ sensor()?.sensorDisplayLabel }}
              </div>
            }
          </div>

          @if (!isRotating()) {
            <app-nav-button
              [primary]="true"
              [class.mobile]="isMobile()"
              [class.tablet]="isTablet()"
              svgIcon="icons:documentation"
              (clickEvent)="overlayDocumentation.set(true)"
            >
              {{ i18n.langString("add_documentation") }}
            </app-nav-button>
          }
        </div>
      </div>

      @if (false) {
        <button class="filter-btn">
          <span>01 Mar 2021 - 7 Mar 2021</span>
          <i nz-icon nzType="icons:edit" class="mini-icon svg-icon"></i>
        </button>
      }

      @if (overlayDocumentation()) {
        <app-docu-wizard
          (closeEvent)="overlayDocumentation.set(false)"
          [assetId]="assetID()"
          [sensorId]="sensorID()"
          (saved)="onDocumentationAdded()"
        >
        </app-docu-wizard>
      }

      <div class="detailhistory-wrapper">
        @for (item of HistoryItems(); track item.sensorID) {
          <app-history-item
            [dateFormat]="dateFormat()"
            [item]="item"
            [asset]="asset()"
            [shadow]="true"
          >
          </app-history-item>
        }
      </div>

      <nz-pagination
        [nzTotal]="historyItems().length"
        (nzPageIndexChange)="pageIndex.set($event)"
      >
      </nz-pagination>
    </div>
  </div>
}
